export default function unsafeHtml($sce) {
    return $sce.trustAsHtml;
};